import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import IframeResizer from 'iframe-resizer-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'

export type RekenToolBlockProps = {
  url: string
}

export type RekenToolBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
}>

export function RekenToolBlock<CustomBlockData, extra_images>(
  props: RekenToolBlockProps,
  options?: { style?: RekenToolBlockStyle; key?: string }
): (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: onDone => (
        <>
          <section
            className={getClassName(options, 'block_classname', '')}
            key={options && options.key ? options.key : 'rekentool-block'}
          >
            <div className={getClassName(options, 'inner_classname', '')}>
              <div className={getClassName(options, 'content_classname', '')}> 
                {/* NOTE: 'wbRekentool' = mandatory className! */}
                <IframeResizer src={props.url}
                  className={getClassName(options, 'iframe_classname', 'wbRekentool')}
                  style={{
                    'width': '100px',
                    'minWidth': '100%',
                    'height': '100px',
                    'border': '0px',
                    'background': 'url("https://rekentools.webbridge.nl/images/spinner.gif") 50% 50% no-repeat',
                    'overflow': 'hidden'
                  }}
                  scrolling={false}
                />
              </div>
            </div>
          </section>

          <RekenToolBlockScripts/>

        </>
      )
    })
}

export function RekenToolBlockScripts() {
  // What this function should achieve is to only add the two required scripts when the page needs it...
  // Instead of adding it to every page by default. 
  let $jqueryScript = document.createElement("script");
  $jqueryScript.type = 'text/javascript';
  $jqueryScript.src = 'https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js';
  $jqueryScript.id = 'jquery-script'
  if (document.documentElement.querySelector('#jquery-script') == null) { // Make sure it's only added once!
    document.documentElement.append($jqueryScript);
  }

  let $rekentoolScript = document.createElement("script");
  $rekentoolScript.type = 'text/javascript';
  $rekentoolScript.src = 'https://rekentools.webbridge.nl/hypotrust/wb-rekentool-iframe.min.js';
  $rekentoolScript.id = 'rekentool-script'
  if (document.documentElement.querySelector('#rekentool-script') == null) { // Make sure it's only added once!
    document.documentElement.append($rekentoolScript);
  }

  return <></>
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/rekentoolBlock.mod.tsx